import isBoolean from 'lodash/isBoolean';

export const getTableNames = (selection: { [tableName: string]: boolean }) => {
  if (!selection) return null;
  return Object.keys(selection).filter(
    (tableName) => isBoolean(selection[tableName]) && !!selection[tableName],
  );
};

export const mapTablesToSelection = (tableNames: string[]) => {
  return tableNames?.reduce(
    (map, name) => {
      map[name] = true;
      map.__selectionCount__ += 1;
      return map;
    },
    { __selectionCount__: 0 },
  );
};
